var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.$store.state.layout === 'desktop')?_c('SetupDesktop'):_c('SetupMobile')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }